var dom = {},

	$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),

	setupDom = function(){

		dom.window = $(window);
		dom.document = $(document);
		dom.boxes = $(".box");

	},

	addEventHandlers = function(){

		// nothing yet

	},

	setupImgBoxHeights = function(){

		var winWidth = dom.window.width(),
			boxImgRatio = .7964,
			imgHeight = winWidth * boxImgRatio,
			naturalBoxWidth = 565,
			$textualBoxes;

		// only constrain the box heights if the widths had to be constrained
		if(dom.window.width() < naturalBoxWidth){

			dom.boxes.height(imgHeight);

			$textualBoxes = dom.boxes.not(".box-image,.box-image-mobile");

			$.each($textualBoxes, function(i, el){

				var $box = $(el),
					contentHeight = $box.find(".box-content").outerHeight(),
					verticalBoxPadding = 50;

				// if the textual box content is taller than the assigned height
				// (based on image proportions), then adjust the height as needed
				// this is common on narrow smartphones (i.e. old iphones)
				if(contentHeight >= imgHeight){

					$box.height(contentHeight + verticalBoxPadding);

				}

			});
			
		}

	},

	init = function(){

		setupDom();
		
		addEventHandlers();

		setupImgBoxHeights();

	};

init();